import React, { FormEvent, useEffect, useState } from "react";
import { ICriteriaGroup } from "../../../types/criteriaGroup";
import { ICriteriaDetails } from "../../../types/criteriaDetails";
import useUpdateCriteriaDetails from "../../../hooks/criteria-details/useUpdateCriteriaDetails";
import useCreateCriteriaDetails from "../../../hooks/criteria-details/useCreateCriteriaDetails";
import useDeleteCriteriaDetails from "../../../hooks/criteria-details/useDeleteCriteriaDetails";
import { IQuestion } from "../../../types/question";

interface ICriteriaDetailsProps {
  criteriaGroups: ICriteriaGroup[];
  currOption: number[];
  setCurrOption: React.Dispatch<React.SetStateAction<number[]>>;
  isDelete: boolean;
  setIsDelete: React.Dispatch<React.SetStateAction<boolean>>;
  setIsOpenDeleteModal: React.Dispatch<React.SetStateAction<boolean>>;
  questions: IQuestion[];
}

const CriteriaDetails = ({
  criteriaGroups,
  currOption,
  setCurrOption,
  isDelete,
  setIsDelete,
  setIsOpenDeleteModal,
  questions,
}: ICriteriaDetailsProps) => {
  //eslint-disable-line

  const criteriaGroupIdx = currOption[0] || 0;
  const criteriaIdx = currOption[1] || 0;
  const criteriaDetailsId = currOption[2] || 0;

  const criteriaId = criteriaGroups[criteriaGroupIdx].criterias[criteriaIdx].id;

  const [criteriaDetail, setCriteriaDetail] = useState(
    criteriaGroups[0].criterias[0].criteria_details[0]
  );
  const [title, setTitle] = useState<string>("");
  const [isProcessRunning, setIsProcessRunning] = useState<boolean>(false);
  const [isServiceError, setIsServiceError] = useState<string | null>(null); //eslint-disable-line

  const blankCriteriaDetails: ICriteriaDetails = {
    criteria_id: criteriaId ?? 0,
    question_id: 1,
    answer: "",
  };

  useEffect(() => {
    if (
      criteriaDetailsId ===
      criteriaGroups[criteriaGroupIdx].criterias[criteriaIdx].criteria_details
        .length
    ) {
      setCriteriaDetail({ ...blankCriteriaDetails });
      setTitle("New criteria detail");
    } else {
      setCriteriaDetail(
        criteriaGroups[criteriaGroupIdx].criterias[criteriaIdx]
          .criteria_details[criteriaDetailsId]
      );
      setTitle(
        criteriaGroups[criteriaGroupIdx].criterias[criteriaIdx]
          .criteria_details[criteriaDetailsId].answer
      );
    }
  }, [criteriaDetailsId, criteriaGroups]); //eslint-disable-line

  const { mutate: updateCriteriaDetail } = useUpdateCriteriaDetails({
    setIsProcessRunning,
    setIsServiceError,
  });
  const { mutate: createCriteriaDetail } = useCreateCriteriaDetails({
    setIsProcessRunning,
    setIsServiceError,
  });
  const { mutate: deleteCriteriaDetail } = useDeleteCriteriaDetails({
    setIsProcessRunning,
    setIsServiceError,
  });

  useEffect(() => {
    if (isDelete) {
      setCurrOption([criteriaGroupIdx, criteriaIdx, 0]);
      if (criteriaDetail.id) deleteCriteriaDetail(criteriaDetail.id);
      setIsDelete(false);
    }
  }, [isDelete]); //eslint-disable-line

  if (!criteriaDetail) {
    return <p>Loading...</p>;
  }

  const handleSave = (e: FormEvent) => {
    e.preventDefault();

    if (
      criteriaDetailsId ===
      criteriaGroups[criteriaGroupIdx].criterias[criteriaIdx].criteria_details
        .length
    ) {
      createCriteriaDetail(criteriaDetail);
    } else {
      updateCriteriaDetail(criteriaDetail);
    }
    setTitle(criteriaDetail.answer);
  };

  const handleDelete = () => {
    if (
      criteriaDetailsId ===
      criteriaGroups[criteriaGroupIdx].criterias[criteriaIdx].criteria_details
        .length
    ) {
      if (!criteriaDetailsId) {
        setCurrOption([criteriaGroupIdx, criteriaIdx]);
      } else {
        setCurrOption([criteriaGroupIdx, criteriaIdx, 0]);
      }
      setCriteriaDetail(
        criteriaGroups[criteriaGroupIdx].criterias[criteriaIdx]
          .criteria_details[criteriaDetailsId]
      );
    } else {
      setIsOpenDeleteModal(true);
    }
  };

  return (
    <div className="imm_quest_admin__content">
      <div className="content_head">
        <h3>{title}</h3>
      </div>

      <form onSubmit={handleSave} className="content_form">
        <div className="field">
          <label htmlFor="question">Question</label>
          <select
            id="question"
            name="question"
            defaultValue={""}
            value={criteriaDetail.question_id || ''}
            onChange={(e) =>
              setCriteriaDetail({
                ...criteriaDetail,
                question_id: parseInt(e.target.value),
              })
            }
          >
            <option value="">-- Select question --</option>
            {questions?.map((question) => (
              <option key={question.id} value={question.id}>
                {question?.page?.title} - {question.question}
              </option>
            ))}
          </select>
        </div>

        <div className="field">
          <label htmlFor="type">Answer</label>
          <input
            id="type"
            name="type"
            placeholder="Enter Type"
            value={criteriaDetail.answer}
            onChange={(e) =>
              setCriteriaDetail({ ...criteriaDetail, answer: e.target.value })
            }
          />
        </div>

        <div className="actions">
          <button className="delete_btn" type="button" onClick={handleDelete}>
            {isProcessRunning ? (
              <i className="imm_quest_admin__process_loader" />
            ) : criteriaDetailsId ===
              criteriaGroups[criteriaGroupIdx].criterias[criteriaIdx]
                .criteria_details.length ? (
              "Cancel"
            ) : (
              "Delete"
            )}
          </button>
          <button className="save_btn" type="submit">
            {isProcessRunning ? (
              <i className="imm_quest_admin__process_loader" />
            ) : criteriaId ===
              criteriaGroups[criteriaGroupIdx].criterias[criteriaIdx]
                .criteria_details.length ? (
              "Create"
            ) : (
              "Save"
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

export default CriteriaDetails;
